import React, { forwardRef } from "react";
import ApperIcon from "@/components/ApperIcon";
import { cn } from "@/utils/cn";

const Select = forwardRef(({
  className,
  children,
  error,
  label,
  placeholder,
  options = [],
  value,
  ...props
}, ref) => {
  const baseClasses = "flex w-full rounded-lg border bg-white px-3 py-2.5 text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 appearance-none";
  
  const normalClasses = "border-gray-300 focus:border-facebook focus:ring-facebook hover:border-gray-400";
  const errorClasses = "border-red-300 focus:border-red-500 focus:ring-red-500";

  return (
    <div className="space-y-1.5">
      {label && (
        <label className="text-sm font-medium text-gray-700">{label}</label>
      )}
      <div className="relative">
        <select
className={cn(
            baseClasses,
            error ? errorClasses : normalClasses,
            className
          )}
          ref={ref}
          value={value || ""}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.length > 0
            ? options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))
            : children}
          {options.length > 0 && children}
        </select>
        <ApperIcon 
          name="ChevronDown" 
          className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" 
        />
      </div>
      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
});

Select.displayName = "Select";

export default Select;